import { useEffect, useState } from 'react';

type PriceBreakdownProps = {
  subTotal: number;
  initialDiscount: number;
  onValuesChange?: (values: { discount: number; total: number }) => void;
  isEditable: boolean;
};

export function PriceBreakdown({
  subTotal,
  initialDiscount,
  onValuesChange,
  isEditable,
}: PriceBreakdownProps) {
  const [discount, setDiscount] = useState<number>(initialDiscount);

  const total = Math.max(subTotal - discount, 0);

  useEffect(() => {
    if (onValuesChange) {
      onValuesChange({ discount, total });
    }
  }, [discount, total, onValuesChange]);

  return (
    <div className="w-80 space-y-4 rounded-md p-4 shadow-sm">
      {/* Subtotal Row */}
      <div className="flex items-center justify-between">
        <span className="font-medium text-gray-700">Subtotal</span>
        <span className="font-medium text-gray-900">
          ${subTotal.toFixed(2)}
        </span>
      </div>

      {/* Discount Input Row */}
      {isEditable && (
        <div className="flex items-center justify-between">
          <label htmlFor="discount" className="font-medium text-gray-700">
            Discount
          </label>
          {/* Replace with Radix input component if desired */}
          <input
            id="discount"
            type="number"
            value={discount}
            min={0}
            onChange={(e) => {
              setDiscount(Number(e.target.value));
            }}
            className="w-24 rounded border border-gray-300 px-2 py-1 text-right focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      )}

      {!isEditable && (
        <div className="flex items-center justify-between">
          <span className="text-gray-800">Discount</span>
          <span className="text-gray-800">${discount.toFixed(2)}</span>
        </div>
      )}

      <hr className="border-gray-200" />

      {/* Total Row */}
      <div className="flex items-center justify-between">
        <span className="font-bold text-gray-800">Total</span>
        <span className="font-bold text-gray-800">${total.toFixed(2)}</span>
      </div>
    </div>
  );
}
